export class ProyectoDispersionDetalle {
  idsProyectos?: string = "";
  idProyecto?: number = -1;
  idUsuario?: number = -1;
  nombre_proyecto: string;
  idLote: number;
  nombre: string;
  idCierre: number;
  idMovimiento: number;
  estatus: string;
  monto_venta: number;
  porcentaje_comision_reda: number;
  monto_comision_reda: number;
  porcentaje_comision_anticipo_reda: number;
  monto_comision_anticipo_reda: number;
  folio_anticipo: string;
  anticipo_estatus: string;
  porcentaje_comision_liquidacion_reda: number;
  monto_comision_liquidacion_reda: number;
  folio_liquidacion: string;
  liquidacion_estatus: string;
  monto_dispersado_anticipo: number;
  monto_dispersado_liquidacion: number;
  utilidad_reda: number;
  fechaInicio: Date;
  fechaFin: Date;
  estatusCierre?: string = "";
  monto_dispersado_anticipo_cantidad_participantes_pagados?: number = 0;
  monto_dispersado_anticipo_cantidad_participantes?: number = 0;
  monto_dispersado_liquidacion_cantidad_participantes_pagados?: number = 0;
  monto_dispersado_liquidacion_cantidad_participantes?: number = 0;

  //
  por_Cobrar: number = 0;
  adeudo_Actual: number = 0;
  cobrado: number = 0;
  comisionTotalDispersar: number = 0;
  porcentajeDispersado: number = 0;
  totalPagado: number = 0;
  pendientesAdeudo: number = 0;

  anticipo_facturaValida: number = 0;
  liquidacion_facturaValida: number = 0;

  monto_dispersado_participantes_pagados: number = 0;
  monto_total_a_dispersar: number = 0;
  nombre_Prospecto: string = "";
}
